import { useEffect, useState } from 'react';
import SegmentApi from 'services/KjederegisteretAdminApi/SegmentApi';
import { SegmenterPerBransje } from 'services/KjederegisteretAdminApi/SegmentApi/types';

let segmenterPromise: Promise<SegmenterPerBransje> | undefined;
const loadSegmenter = () => {
  segmenterPromise ??= SegmentApi.getSegmenterPerBransje().catch((e) => {
    segmenterPromise = undefined;
    throw e;
  });
  return segmenterPromise;
};

/** Bransjer som har segmenter, med gyldige verdier. Hentes én gang og caches. */
const useSegmenterPerBransje = (): SegmenterPerBransje | undefined => {
  const [segmenter, setSegmenter] = useState<SegmenterPerBransje>();

  useEffect(() => {
    let isSubscribed = true;
    loadSegmenter()
      .then((data) => isSubscribed && setSegmenter(data))
      .catch(() => undefined);
    return () => {
      isSubscribed = false;
    };
  }, []);

  return segmenter;
};

export default useSegmenterPerBransje;
